import { Link } from "react-router-dom";
import { Draggable } from "react-beautiful-dnd";
import FilmanizeCheckbox from "../../../../shared/filmanize-checkbox";

function Shot(props) {
  const {
    shot,
    filmId,
    sceneId,
    index,
    readOnly,
    isSelected,
    toggleSelection,
    toggleSelectionInGroup,
    multiSelectTo,
    deleteing
  } = props;

  const grid = 0;
  const getItemStyle = (isDragging, draggableStyle, isSelected) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,
    // change background colour if dragging    
    background: isSelected ? "#222E44" : isDragging ? "#947eed" : "#040f21",

    // styles we need to apply on draggables
    ...draggableStyle
  });

  const primaryButton = 0;

  // Using onClick as it will be correctly
  // preventing if there was a drag
  const onClick = (event: MouseEvent) => {
    if (event.defaultPrevented) {
      return;
    }

    if (event.button !== primaryButton) {
      return;
    }

    // marking the event as used
    event.preventDefault();

    performAction(event);
  };

  // Determines if the platform specific toggle selection in group key was used
  const wasToggleInSelectionGroupKeyUsed = (
    event: MouseEvent | KeyboardEvent
  ) => {
    const isUsingWindows = navigator.platform.indexOf("Win") >= 0;
    return isUsingWindows ? event.ctrlKey : event.metaKey;
  };

  // Determines if the multiSelect key was used
  const wasMultiSelectKeyUsed = (event: MouseEvent | KeyboardEvent) =>
    event.shiftKey;

  const performAction = (event: MouseEvent | KeyboardEvent) => {
    if (wasToggleInSelectionGroupKeyUsed(event)) {
      toggleSelectionInGroup(shot.id);
      return;
    }

    if (wasMultiSelectKeyUsed(event)) {
      multiSelectTo(shot.id);
      return;
    }

    toggleSelection(shot.id);
  };

  const link = `/films/${filmId}/scenes/${sceneId}/shots/${shot.id}/edit`;

  return (
    <Draggable key={shot.id} draggableId={shot.id} index={index} isDragDisabled={readOnly}>
      {(provided, snapshot) => (
        <>
          <tr
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style,
              isSelected
            )}
            onClick={(event: any) => onClick(event as any)}>
            {!readOnly && (
              <td onClick={(e) => e.stopPropagation()}>
                <FilmanizeCheckbox
                  checked={isSelected}
                  disabled={deleteing}
                  onChange={() => toggleSelection(shot.id)}
                />
              </td>
            )}
            <td>
              {!readOnly && <i className="material-icons">drag_indicator</i>}
              <Link to={link}>
                {shot.number}
              </Link>
            </td>
            <td>
              <Link to={link}>
                {shot.shotSizeDescription}
              </Link>
            </td>
            <td>
              {shot.lensFocalLength}
              {/* {shot.lensFocalLength && <>mm</>} */}
            </td>
            <td>
              {shot.characters.join(', ')}
            </td>
            <td>
              {shot.backgroundCharacters.join(', ')}
            </td>
          </tr>
        </>
      )}
    </Draggable>
  );
}

export default Shot;
